//Reset data
export const RESET = "RAPPORT_INFO_RESET"

//Loading
export const SET_TOGGLE_LOADING = "RAPPORT_INFO_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "RAPPORT_INFO_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "RAPPORT_INFO_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "RAPPORT_INFO_SET_MESSAGE"
export const SET_IS_SUCCESS = "RAPPORT_INFO_SET_IS_SUCCESS"
export const SET_IS_ERROR = "RAPPORT_INFO_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "RAPPORT_INFO_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "RAPPORT_INFO_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "RAPPORT_INFO_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "RAPPORT_INFO_SET_ITEMS"
export const SET_FILTER = "RAPPORT_INFO_SET_FILTER"
export const SET_CURRENT_ITEM = "RAPPORT_INFO_SET_CURRENT_ITEM"
